<template>
  <div class="public-profile">
    <!-- Header/Navigation -->
    <header class="header bg-white shadow-sm">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center py-3">
          <!-- Logo -->
          <div class="d-flex align-items-center">
            <img :src="logo" class="me-2" style="height: 32px; width: auto" alt="Logo" />
            <h4 class="ms-1 font-weight-bold">Diário de Treino</h4>
          </div>

          <!-- Navigation -->
          <div class="d-flex gap-3">
            <button class="btn btn-outline-primary rounded-pill px-4">Quem Somos</button>

            <!-- Contact Form Modal Trigger -->
            <button
              class="btn btn-outline-success rounded-pill px-4"
              data-bs-toggle="modal"
              data-bs-target="#contactModal"
            >
              <i class="fas fa-envelope me-2"></i>Contato
            </button>
          </div>

          <!-- Contact Info -->
          <div class="text-end">
            <small class="text-muted">Contato do Professor</small>
            <div class="fw-bold">{{ profile.telefone }}</div>
          </div>

          <!-- ENTRAR Button -->
          <button class="btn btn-indigo text-white px-4 rounded-pill" @click="irParaLogin">
            ENTRAR
          </button>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main>
      <!-- Hero Section -->
      <section class="hero-section py-5">
        <div class="container">
          <div class="row align-items-stretch">
            <!-- Área do vídeo (maior parte - COMO ESTAVA) -->
            <div class="col-lg-9 mb-4 mb-lg-0 d-flex">
              <div
                class="bg-white rounded-4 p-4 w-100 d-flex align-items-center justify-content-center"
                style="min-height: 320px"
              >
                <video
                  v-if="profile.video_apresentacao"
                  :src="fullUrl(profile.video_apresentacao)"
                  controls
                  style="width: 100%; max-height: 350px; border-radius: 12px"
                ></video>
                <div v-else class="text-muted">Vídeo não disponível</div>
              </div>
            </div>
            <!-- Lateral: Foto e Currículo (FOTO MAIOR + FONTE MENOR) -->
            <div class="col-lg-3 d-flex flex-column">
              <div class="bg-white rounded-4 p-2 mb-2 d-flex flex-column align-items-center" style="flex: 1 1 auto;">
                <img
                  v-if="profile.profile_image_url"
                  :src="fullUrl(profile.profile_image_url)"
                  alt="Foto do Treinador"
                  class="img-fluid rounded"
                  style="max-width: 100%; height: 100%; max-height: 450px; object-fit: cover; width: 100%;"
                />
                <div v-else class="text-muted">Foto não disponível</div>
              </div>
              <div class="bg-white rounded-4 p-2" style="flex: 0 0 auto; max-height: 120px;">
                <div class="fw-semibold mb-1 text-center" style="font-size: 0.8rem;">Currículo Resumido</div>
                <div
                  class="text-center"
                  style="font-size: 0.65rem; line-height: 1.2; max-height: 90px; overflow-y: auto; padding: 0 0.5rem;"
                  v-html="profile.biografia || 'O treinador está no mercado há mais de 10 anos!'"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Services Section -->
      <section class="services-section py-5">
        <div class="container">
          <h3 class="text-center mb-5 text-dark">Escolha a solução que você procura:</h3>

          <div class="row g-4">
            <div class="col-md-4 col-lg-2-4">
              <div class="service-card bg-white rounded-4 p-4 text-center shadow-sm h-100">
                <div class="icon-container mb-3">
                  <i class="fas fa-clipboard-list fa-2x text-orange"></i>
                </div>
                <div class="bg-light-blue rounded-3 p-2">
                  <h6 class="fw-bold text-dark mb-0">Consultoria</h6>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-lg-2-4">
              <div class="service-card bg-white rounded-4 p-4 text-center shadow-sm h-100">
                <div class="icon-container mb-3">
                  <i class="fas fa-dumbbell fa-2x text-orange"></i>
                </div>
                <div class="bg-light-blue rounded-3 p-2">
                  <h6 class="fw-bold text-dark mb-0">Controle de Cargas</h6>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-lg-2-4">
              <div class="service-card bg-white rounded-4 p-4 text-center shadow-sm h-100">
                <div class="icon-container mb-3">
                  <i class="fas fa-user-friends fa-2x text-orange"></i>
                </div>
                <div class="bg-light-blue rounded-3 p-2">
                  <h6 class="fw-bold text-dark mb-0">Treinos Personalizados</h6>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-lg-2-4">
              <div class="service-card bg-white rounded-4 p-4 text-center shadow-sm h-100">
                <div class="icon-container mb-3">
                  <i class="fas fa-clipboard-check fa-2x text-orange"></i>
                </div>
                <div class="bg-light-blue rounded-3 p-2">
                  <h6 class="fw-bold text-dark mb-0">Planilhas de Treinos</h6>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-lg-2-4">
              <div class="service-card bg-white rounded-4 p-4 text-center shadow-sm h-100">
                <div class="icon-container mb-3">
                  <i class="fas fa-trophy fa-2x text-orange"></i>
                </div>
                <div class="bg-light-blue rounded-3 p-2">
                  <h6 class="fw-bold text-dark mb-0">Avaliação Física</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Posts/Gallery Section -->
      <section class="posts-section py-5">
        <div class="container">
          <div class="row g-4">
            <div v-for="(img, index) in galeriaFiltrada" :key="index" class="col-md-4 col-lg-2-4">
              <div
                class="post-card bg-light-blue rounded-4 p-4 text-center text-dark shadow-sm h-100"
              >
                <img
                  :src="fullUrl(img)"
                  alt="Foto da galeria"
                  class="img-fluid rounded"
                  style="max-height: 200px; object-fit: cover; width: 100%"
                />
              </div>
            </div>

            <!-- Mensagem quando não há fotos -->
            <div v-if="galeriaFiltrada.length === 0" class="col-12 text-center">
              <div class="bg-light-blue rounded-4 p-5 text-dark">
                <i class="fas fa-images fa-3x mb-3 text-muted"></i>
                <h5 class="text-dark">Nenhuma foto disponível</h5>
                <p class="text-muted">O treinador ainda não adicionou fotos à galeria.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- Footer -->
    <footer class="footer bg-white text-dark py-4">
      <div class="container">
        <div class="row">
          <!-- Social Media -->
          <div class="col-md-6">
            <h6 class="fw-bold mb-3 text-dark">Mídias Sociais</h6>
            <div class="d-flex gap-3">
              <a
                v-if="profile.redes_sociais?.instagram"
                :href="'https://instagram.com/' + profile.redes_sociais.instagram"
                target="_blank"
                class="text-dark"
              >
                <i class="fab fa-instagram fa-lg"></i>
              </a>
              <a
                v-if="profile.redes_sociais?.facebook"
                :href="'https://facebook.com/' + profile.redes_sociais.facebook"
                target="_blank"
                class="text-dark"
              >
                <i class="fab fa-facebook fa-lg"></i>
              </a>
              <a
                v-if="profile.redes_sociais?.youtube"
                :href="'https://youtube.com/' + profile.redes_sociais.youtube"
                target="_blank"
                class="text-dark"
              >
                <i class="fab fa-youtube fa-lg"></i>
              </a>
              <a
                v-if="profile.redes_sociais?.linkedin"
                :href="'https://linkedin.com/in/' + profile.redes_sociais.linkedin"
                target="_blank"
                class="text-dark"
              >
                <i class="fab fa-linkedin fa-lg"></i>
              </a>
            </div>
            <div class="mt-2">
              <small class="text-dark">Instagram | FaceBook | YouTube | LinkedIn</small>
            </div>
          </div>

          <!-- Contact Info -->
          <div class="col-md-6 text-md-end">
            <h6 class="fw-bold mb-3 text-dark">Contato:</h6>
            <div class="mb-1">
              <small class="text-dark">Telefone:</small>
              <div class="text-dark">{{ profile.telefone || '31997818033' }}</div>
            </div>
            <div class="mb-1">
              <small class="text-dark">WhatsApp:</small>
              <div class="text-dark">{{ profile.telefone || '31997818033' }}</div>
            </div>
            <div class="mb-1">
              <small class="text-dark">Email:</small>
              <div class="text-dark">{{ profile.email }}</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>

  <!-- Contact Form Modal -->
  <div
    class="modal fade"
    id="contactModal"
    tabindex="-1"
    aria-labelledby="contactModalLabel"
    aria-hidden="true"
    role="dialog"
    aria-modal="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="contactModalLabel">
            <i class="fas fa-envelope text-primary me-2"></i>
            Entre em Contato
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fechar modal"
            @click="closeModal"
          ></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="sendContactForm">
            <div class="mb-3">
              <label for="contactName" class="form-label">Nome *</label>
              <input
                type="text"
                class="form-control"
                id="contactName"
                v-model="contactForm.name"
                required
                placeholder="Seu nome completo"
              />
            </div>

            <div class="mb-3">
              <label for="contactEmail" class="form-label">Email *</label>
              <input
                type="email"
                class="form-control"
                id="contactEmail"
                v-model="contactForm.email"
                required
                placeholder="seu@email.com"
              />
            </div>

            <div class="mb-3">
              <label for="contactPhone" class="form-label">Telefone</label>
              <input
                type="tel"
                class="form-control"
                id="contactPhone"
                v-model="contactForm.phone"
                placeholder="(11) 99999-9999"
              />
            </div>

            <div class="mb-3">
              <label for="contactSubject" class="form-label">Assunto *</label>
              <select
                class="form-select"
                id="contactSubject"
                v-model="contactForm.subject"
                required
              >
                <option value="">Selecione um assunto</option>
                <option value="consultoria">Consultoria</option>
                <option value="treino-personalizado">Treino Personalizado</option>
                <option value="avaliacao-fisica">Avaliação Física</option>
                <option value="planilhas">Planilhas de Treino</option>
                <option value="outro">Outro</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="contactMessage" class="form-label">Mensagem *</label>
              <textarea
                class="form-control contact-textarea"
                id="contactMessage"
                rows="4"
                v-model="contactForm.message"
                required
                placeholder="Conte-nos sobre seus objetivos e como podemos ajudar..."
                style="resize: vertical; min-height: 100px"
              ></textarea>
            </div>

            <div class="d-grid gap-2">
              <button type="submit" class="btn btn-primary" :disabled="contactForm.loading">
                <span v-if="contactForm.loading">
                  <i class="fas fa-spinner fa-spin me-2"></i>Enviando...
                </span>
                <span v-else> <i class="fas fa-paper-plane me-2"></i>Enviar Mensagem </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import logo from '@/assets/img/logos/logo.png'

export default {
  name: 'PublicProfile',
  data() {
    return {
      logo,
      profile: {
        nome: '',
        email: '',
        telefone: '',
        biografia: '',
        video_apresentacao: null,
        profile_image_url: '',
        redes_sociais: {
          instagram: null,
          facebook: null,
          linkedin: null,
          youtube: null,
        },
        galeria: [],
      },
      contactForm: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        loading: false,
      },
      baseUrl: 'https://diariodetreino.agilesaas.sbs/storage/',
      loading: true,
    }
  },
  computed: {
    galeriaFiltrada() {
      // Remove itens nulos no array da galeria
      return this.profile.galeria?.filter((item) => item != null) || []
    },
  },
  mounted() {
    const pageName = this.$route.params.slug
    axios
      .get(`https://diariodetreino.agilesaas.sbs/api/public/treinador/page/${pageName}`)
      .then((res) => {
        if (res.data) {
          this.profile = res.data
        }
      })
      .catch((err) => {
        console.error('Erro ao carregar perfil público:', err)
        // Poderia redirecionar pra /404 ou exibir um alerta
      })
      .finally(() => {
        this.loading = false
      })

    // Garantir que o textarea funcione
    this.$nextTick(() => {
      const textarea = document.getElementById('contactMessage')
      if (textarea) {
        textarea.addEventListener('input', (e) => {
          this.contactForm.message = e.target.value
        })
      }
    })
  },
  methods: {
    fullUrl(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      return this.baseUrl + path
    },

    async sendContactForm() {
      this.contactForm.loading = true

      try {
        // Dados completos conforme esperado pelo backend
        const formData = {
          name: this.contactForm.name,
          email: this.contactForm.email,
          phone: this.contactForm.phone,
          subject: this.contactForm.subject,
          message: this.contactForm.message,
          trainerSlug: this.$route.params.slug,
          trainerEmail: this.profile.email,
        }

        console.log('Enviando dados:', formData)

        // Chamada para a API
        const response = await axios.post(
          'https://diariodetreino.agilesaas.sbs/api/contact',
          formData,
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            timeout: 10000, // 10 segundos de timeout
          },
        )

        console.log('Resposta:', response.data)

        if (response.data.success) {
          this.showSuccessMessage()
          this.resetContactForm()

          // Fechar modal de forma segura
          this.closeModal()
        } else {
          this.showErrorMessage()
        }
      } catch (error) {
        console.error('Erro completo:', error)

        // Mostrar detalhes do erro
        if (error.response) {
          console.error('Status:', error.response.status)
          console.error('Headers:', error.response.headers)
          console.error('Data:', error.response.data)

          let errorMessage = ''
          if (error.response.status === 500) {
            errorMessage =
              '⚠️ Problema temporário no servidor. Sua mensagem foi salva e será processada em breve.'
          } else if (error.response.data && error.response.data.message) {
            errorMessage = `Erro ${error.response.status}: ${error.response.data.message}`
          } else {
            errorMessage = `Erro ${error.response.status}: Problema ao processar sua solicitação`
          }

          if (this.$swal) {
            this.$swal({
              icon: 'warning',
              title: '⚠️ Atenção',
              text: errorMessage,
              confirmButtonText: 'OK',
            })
          } else {
            alert(errorMessage)
          }
        } else if (error.request) {
          console.error('Request:', error.request)
          const message = 'Erro de conexão. Verifique sua internet e tente novamente.'
          if (this.$swal) {
            this.$swal({
              icon: 'error',
              title: '❌ Erro de Conexão',
              text: message,
              confirmButtonText: 'OK',
            })
          } else {
            alert(message)
          }
        } else {
          console.error('Error:', error.message)
          const message = `Erro: ${error.message}`
          if (this.$swal) {
            this.$swal({
              icon: 'error',
              title: '❌ Erro',
              text: message,
              confirmButtonText: 'OK',
            })
          } else {
            alert(message)
          }
        }

        // Fallback: mostrar dados que tentamos enviar
        console.log('Dados que tentamos enviar:', {
          name: this.contactForm.name,
          email: this.contactForm.email,
          phone: this.contactForm.phone,
          subject: this.contactForm.subject,
          message: this.contactForm.message,
          trainerSlug: this.$route.params.slug,
          trainerEmail: this.profile.email,
        })
      } finally {
        this.contactForm.loading = false
      }
    },

    resetContactForm() {
      this.contactForm = {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        loading: false,
      }
    },

    showSuccessMessage() {
      // Usar SweetAlert2 se disponível, senão usar alert padrão
      if (this.$swal) {
        this.$swal({
          icon: 'success',
          title: '✅ Mensagem Enviada!',
          text: 'Sua mensagem foi enviada com sucesso. Entraremos em contato em breve!',
          confirmButtonText: 'OK',
        })
      } else {
        alert('✅ Mensagem enviada com sucesso! Entraremos em contato em breve.')
      }
    },

    showErrorMessage() {
      if (this.$swal) {
        this.$swal({
          icon: 'error',
          title: '❌ Erro ao Enviar',
          text: 'Houve um problema ao enviar sua mensagem. Tente novamente.',
          confirmButtonText: 'OK',
        })
      } else {
        alert('❌ Erro ao enviar mensagem. Tente novamente.')
      }
    },

    closeModal() {
      // Método seguro para fechar modal
      const modal = document.getElementById('contactModal')
      if (modal) {
        // Remover classes do modal
        modal.classList.remove('show')
        modal.style.display = 'none'
        modal.setAttribute('aria-hidden', 'true')

        // Remover backdrop
        const backdrop = document.querySelector('.modal-backdrop')
        if (backdrop) {
          backdrop.remove()
        }

        // Reativar scroll e remover aria-hidden do body
        document.body.classList.remove('modal-open')
        document.body.style.overflow = ''
        document.body.style.paddingRight = ''
        document.body.removeAttribute('aria-hidden')

        // Remover focus do botão de fechar
        const closeButton = modal.querySelector('.btn-close')
        if (closeButton) {
          closeButton.blur()
        }
      }
    },

    irParaLogin() {
      window.location.href = 'https://diariodetreinoweb.agilesaas.com.br/login'
    },
  },
}
</script>

<style scoped>
.public-profile {
  min-height: 100vh;
  background-color: #e8f4f8; /* Azul claro/teal */
}

.header {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.hero-section {
  background-color: #f0f8ff; /* Azul muito claro/Alice Blue */
  color: #333;
}

.service-card {
  transition: transform 0.3s ease;
  cursor: pointer;
}

.service-card:hover {
  transform: translateY(-5px);
}

.post-card {
  transition: transform 0.3s ease;
  cursor: pointer;
}

.post-card:hover {
  transform: translateY(-5px);
}

/* Custom colors */
.bg-light-blue {
  background-color: #b8e6e6 !important; /* Azul claro */
}

.text-orange {
  color: #ff6b35 !important; /* Laranja */
}

.btn-indigo {
  background-color: #4f46e5 !important; /* Roxo/índigo */
  border-color: #4f46e5 !important;
}

.btn-indigo:hover {
  background-color: #4338ca !important;
  border-color: #4338ca !important;
}

.text-primary {
  color: #1e40af !important; /* Azul escuro */
}

.icon-container {
  width: 60px;
  height: 60px;
  border: 2px solid #b8e6e6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

/* Custom column width for 5 items */
@media (min-width: 992px) {
  .col-lg-2-4 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}

.footer {
  margin-top: auto;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .header .d-flex {
    flex-direction: column;
    gap: 1rem;
  }

  .hero-section .row {
    flex-direction: column-reverse;
  }
}

/* Contact form styles */
.contact-textarea {
  font-family: inherit;
  line-height: 1.5;
  padding: 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.contact-textarea:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.contact-textarea:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
</style>
